<div class="cand-modal sms-modal" *ngIf="visibility">
    <article *ngIf="visibility" [@slideInOut] class="cand-modal__overlay">
        <em class="cand-modal__overlay__close circle-close-icon" (click)="buttonCrossClick()"></em>
        <h1 class="cand-modal__title">
            {{ modalTitle | i18n }}
        </h1>
        <section class="cand-modal__content sms-modal__content">
            <div>
                <p *ngIf="icon" class="iconblock iconblock--sms sms-modal__iconblock"></p>
                <p *ngIf="iconInfo" class="iconblock modal-info__iconblock"></p>
                <p class="sms-modal__message sms-modal__message">
                    {{ content | i18n }}
                    <span id="telephone">{{ telephone }}</span>
                    <span *ngIf="postAppointmentModalContent"> {{ postAppointmentModalContent | i18n }}</span>
                </p>
            </div>
        </section>
        <footer class="cand-modal__footer">
            <p>
                <button
                    class="button button--primary modal-info__next-button"
                    data-tag-commander=""
                    [appTagCommander]="'tagCo.documentselection.documentselectiontype.desktop.sendsms.button'"
                    data-api-call-button=""
                    (click)="buttonRightClick()"
                >
                    <span class="ng-binding">{{ buttonRight | i18n }}</span>
                </button>
                <button *ngIf="buttonLeft" class="button--previous-cancel modal-info__cancel-button ng-binding" (click)="buttonCrossClick()">
                    {{ buttonLeft | i18n }}
                </button>
            </p>
        </footer>
    </article>
    <div class="cand-modal__fade" data-ng-click="sendSmsModal.closeModal()" *ngIf="visibility" [@fadeInOut] (click)="buttonCrossClick()"></div>
</div>
